(() => {
  const TERMS = [
    {
      slug: "lichun",
      zh: "立春",
      roman: "Lichun",
      english: "Start of Spring",
      month: 2,
      day: 4,
      season: "Spring",
      meaning: "Spring begins and the year turns toward fresh growth.",
      mood: "Fresh / Open / Renewing",
      balance: "Softness / Light / Ease",
      wear: "Light pieces / Soft shine / Fresh gold or pearl-look accents",
      copy: "Lichun opens the year toward fresh growth, brighter light, and a quieter sense of renewal. Dress with the season through lighter pieces, soft shine, fresh gold tones, and pearl-look accents."
    },
    {
      slug: "yushui",
      zh: "雨水",
      roman: "Yushui",
      english: "Rain Water",
      month: 2,
      day: 18,
      season: "Spring",
      meaning: "Early rain softens the ground and signals new life.",
      mood: "Soft / Fresh / Gentle",
      balance: "Clarity / Delicacy / Calm",
      wear: "Pearl-look / Clear stones / Delicate everyday jewelry",
      copy: "Yushui brings a softer spring rhythm, with early rain and new life shaping the mood of the moment. Dress with pearl-look details, clear stones, and delicate everyday jewelry."
    },
    {
      slug: "jingzhe",
      zh: "惊蛰",
      roman: "Jingzhe",
      english: "Awakening of Insects",
      month: 3,
      day: 5,
      season: "Spring",
      meaning: "Warmth returns and dormant energy starts to move.",
      mood: "Awake / Moving / Playful",
      balance: "Brightness / Shape / Lift",
      wear: "Brighter details / Playful shapes / Subtle statement pieces",
      copy: "Jingzhe marks spring waking into motion, when warmth returns and daily dressing can feel more expressive. Dress with brighter details, playful shapes, and subtle statement pieces."
    },
    {
      slug: "chunfen",
      zh: "春分",
      roman: "Chunfen",
      english: "Spring Equinox",
      month: 3,
      day: 20,
      season: "Spring",
      meaning: "Day and night come into balance as spring opens fully.",
      mood: "Balanced / Open / Clear",
      balance: "Symmetry / Ease / Freshness",
      wear: "Balanced silhouettes / Classic pieces / Soft symmetry",
      copy: "Chunfen brings balanced light as spring opens fully. Dress with balanced silhouettes, classic pieces, and soft symmetry that feels polished without weight."
    },
    {
      slug: "qingming",
      zh: "清明",
      roman: "Qingming",
      english: "Clear and Bright",
      month: 4,
      day: 5,
      season: "Spring",
      meaning: "Clear air and bright light bring a fresh, reflective mood.",
      mood: "Clear / Bright / Reflective",
      balance: "Clean lines / Cool shine / Light",
      wear: "Clean silver-tone / Clear crystal-like accents / Minimal lines",
      copy: "Qingming carries clear air, bright light, and a fresh reflective mood. Dress with clean silver-tone pieces, clear crystal-like accents, and minimal lines."
    },
    {
      slug: "guyu",
      zh: "谷雨",
      roman: "Guyu",
      english: "Grain Rain",
      month: 4,
      day: 20,
      season: "Spring",
      meaning: "Rain nourishes the fields and growth becomes visible.",
      mood: "Nourished / Growing / Gentle",
      balance: "Green / Organic / Soft warmth",
      wear: "Green accents / Floral or organic shapes / Gentle gold-tone",
      copy: "Guyu brings nourishing rain and visible growth, with spring feeling fuller and more textured. Dress with green accents, organic shapes, and gentle gold-tone jewelry."
    },
    {
      slug: "lixia",
      zh: "立夏",
      roman: "Lixia",
      english: "Start of Summer",
      month: 5,
      day: 5,
      season: "Summer",
      meaning: "Summer begins with brighter days and outward energy.",
      mood: "Bright / Outward / Warm",
      balance: "Confidence / Shine / Ease",
      wear: "Warm gold-tone / Confident earrings / Bright accents",
      copy: "Lixia begins the summer rhythm, with brighter days and a more outward mood. Dress with warm gold-tone pieces, confident earrings, and bright accents."
    },
    {
      slug: "xiaoman",
      zh: "小满",
      roman: "Xiaoman",
      english: "Grain Buds",
      month: 5,
      day: 21,
      season: "Summer",
      meaning: "Growth is nearly full, carrying a feeling of promise.",
      mood: "Full / Promising / Soft",
      balance: "Rounded form / Warmth / Gentle shine",
      wear: "Soft statement pieces / Pearl-look / Rounded forms",
      copy: "Xiaoman carries the feeling of promise, with growth nearly full and summer still soft around the edges. Dress with soft statement pieces, pearl-look details, and rounded forms."
    },
    {
      slug: "mangzhong",
      zh: "芒种",
      roman: "Mangzhong",
      english: "Grain in Ear",
      month: 6,
      day: 5,
      season: "Summer",
      meaning: "A busy early-summer term linked with ripening grain, heat, and momentum.",
      mood: "Bright / Active / Growing",
      balance: "Softness / Clarity / Grounding",
      wear: "Gold-tone / Pearl-inspired / Green accents",
      copy: "Mangzhong marks a busy early-summer season, when warmth rises, growth accelerates, and daily life feels more active. Dress with warm gold tones, pearl-inspired details, clear crystals, and green accents."
    },
    {
      slug: "xiazhi",
      zh: "夏至",
      roman: "Xiazhi",
      english: "Summer Solstice",
      month: 6,
      day: 21,
      season: "Summer",
      meaning: "The longest daylight of the year brings peak brightness.",
      mood: "Peak light / Bright / Expansive",
      balance: "Clarity / Reflective shine / Ease",
      wear: "Reflective shine / Clear stones / Statement earrings",
      copy: "Xiazhi brings the year&apos;s longest daylight and a peak-bright summer mood. Dress with reflective shine, clear stones, and statement earrings that feel luminous without heaviness."
    },
    {
      slug: "xiaoshu",
      zh: "小暑",
      roman: "Xiaoshu",
      english: "Minor Heat",
      month: 7,
      day: 7,
      season: "Summer",
      meaning: "Heat rises, but the season has not reached its fullest intensity.",
      mood: "Warm / Rising / Light",
      balance: "Coolness / Air / Clear shine",
      wear: "Lightweight jewelry / Cool silver-tone / Clear accents",
      copy: "Xiaoshu begins the rise of deeper summer heat while the season still has room to breathe. Dress with lightweight jewelry, cool silver-tone, and clear accents."
    },
    {
      slug: "dashu",
      zh: "大暑",
      roman: "Dashu",
      english: "Major Heat",
      month: 7,
      day: 23,
      season: "Summer",
      meaning: "The hottest part of summer calls for ease and balance.",
      mood: "Hot / Open / Easy",
      balance: "Minimal / Cooling / Balanced",
      wear: "Minimal pieces / Cooling colors / Breathable styling",
      copy: "Dashu is the fullest heat of summer, a moment for ease, clean styling, and pieces that do not feel heavy. Dress with minimal jewelry, cooling colors, and breathable styling."
    },
    {
      slug: "liqiu",
      zh: "立秋",
      roman: "Liqiu",
      english: "Start of Autumn",
      month: 8,
      day: 7,
      season: "Autumn",
      meaning: "Autumn begins quietly while summer warmth still lingers.",
      mood: "Transitional / Quiet / Warm",
      balance: "Polish / Mix / Refinement",
      wear: "Polished classics / Gold-to-silver mixing / Refined lines",
      copy: "Liqiu begins autumn quietly while summer warmth still lingers. Dress with polished classics, gold-to-silver mixing, and refined lines for the shift in rhythm."
    },
    {
      slug: "chushu",
      zh: "处暑",
      roman: "Chushu",
      english: "End of Heat",
      month: 8,
      day: 23,
      season: "Autumn",
      meaning: "Heat starts to fade and the air begins to settle.",
      mood: "Settling / Clear / Released",
      balance: "Calm shine / Everyday ease / Cool tone",
      wear: "Calmer shine / Silver-tone / Everyday pieces",
      copy: "Chushu signals heat beginning to fade, with the air settling into a calmer rhythm. Dress with calmer shine, silver-tone pieces, and easy everyday jewelry."
    },
    {
      slug: "bailu",
      zh: "白露",
      roman: "Bailu",
      english: "White Dew",
      month: 9,
      day: 7,
      season: "Autumn",
      meaning: "Cooler mornings arrive with a clearer, more delicate mood.",
      mood: "Delicate / Cool / Clear",
      balance: "Pearl-look / Transparency / Cool shine",
      wear: "Pearl-look / Clear stones / Cool-tone jewelry",
      copy: "Bailu brings cooler mornings and a delicate clarity to the season. Dress with pearl-look details, clear stones, and cool-tone jewelry."
    },
    {
      slug: "qiufen",
      zh: "秋分",
      roman: "Qiufen",
      english: "Autumn Equinox",
      month: 9,
      day: 23,
      season: "Autumn",
      meaning: "Light and dark balance again as autumn deepens.",
      mood: "Balanced / Focused / Refined",
      balance: "Symmetry / Classic lines / Understatement",
      wear: "Symmetrical designs / Classic jewelry / Understated statement",
      copy: "Qiufen brings light and dark back into balance as autumn deepens. Dress with symmetrical designs, classic jewelry, and understated statement pieces."
    },
    {
      slug: "hanlu",
      zh: "寒露",
      roman: "Hanlu",
      english: "Cold Dew",
      month: 10,
      day: 8,
      season: "Autumn",
      meaning: "A crisp chill appears, bringing a calmer seasonal tone.",
      mood: "Crisp / Calm / Focused",
      balance: "Polished metal / Depth / Refinement",
      wear: "Polished metal / Refined necklaces / Deeper tones",
      copy: "Hanlu brings a crisp chill and a calmer seasonal tone. Dress with polished metal, refined necklaces, and deeper tones."
    },
    {
      slug: "shuangjiang",
      zh: "霜降",
      roman: "Shuangjiang",
      english: "Frost Descent",
      month: 10,
      day: 23,
      season: "Autumn",
      meaning: "First frost signals a move toward stillness and storage.",
      mood: "Still / Grounded / Structured",
      balance: "Darker accents / Shape / Weight",
      wear: "Darker accents / Structured shapes / Grounding pieces",
      copy: "Shuangjiang brings the first frost mood, with the season moving toward stillness and storage. Dress with darker accents, structured shapes, and grounding pieces."
    },
    {
      slug: "lidong",
      zh: "立冬",
      roman: "Lidong",
      english: "Start of Winter",
      month: 11,
      day: 7,
      season: "Winter",
      meaning: "Winter begins, inviting protection and inner warmth.",
      mood: "Quiet / Warm / Close",
      balance: "Warm metal / Pearl-look / Body-close styling",
      wear: "Warmer metals / Pearl-look / Close-to-body pieces",
      copy: "Lidong begins winter, when outfits shift toward quiet texture and inner warmth. Dress with warmer metals, pearl-look details, and close-to-body pieces."
    },
    {
      slug: "xiaoxue",
      zh: "小雪",
      roman: "Xiaoxue",
      english: "Minor Snow",
      month: 11,
      day: 22,
      season: "Winter",
      meaning: "The first light snow brings a quieter seasonal rhythm.",
      mood: "Quiet / Soft / Light",
      balance: "Soft shine / Subtle sparkle / Delicacy",
      wear: "Soft shine / Delicate silver-tone / Subtle sparkle",
      copy: "Xiaoxue brings a quieter seasonal rhythm, like the first light snow of winter. Dress with soft shine, delicate silver-tone, and subtle sparkle."
    },
    {
      slug: "daxue",
      zh: "大雪",
      roman: "Daxue",
      english: "Major Snow",
      month: 12,
      day: 7,
      season: "Winter",
      meaning: "Deeper winter arrives with stronger cold and calm.",
      mood: "Deep / Calm / Bright",
      balance: "Statement shine / Crystal-like light / Winter texture",
      wear: "Statement shine / Crystal-like accents / Winter outfit focus",
      copy: "Daxue brings deeper winter with stronger cold and calm. Dress with statement shine, crystal-like accents, and pieces that give winter outfits a clear focal point."
    },
    {
      slug: "dongzhi",
      zh: "冬至",
      roman: "Dongzhi",
      english: "Winter Solstice",
      month: 12,
      day: 22,
      season: "Winter",
      meaning: "The longest night marks the turning point back toward light.",
      mood: "Warm / Turning / Meaningful",
      balance: "Gold-tone / Pendant focus / Gift-ready polish",
      wear: "Warm gold-tone / Meaningful pendants / Gift-ready jewelry",
      copy: "Dongzhi marks the longest night and the quiet turn back toward light. Dress with warm gold-tone pieces, meaningful pendants, and gift-ready jewelry."
    },
    {
      slug: "xiaohan",
      zh: "小寒",
      roman: "Xiaohan",
      english: "Minor Cold",
      month: 1,
      day: 5,
      season: "Winter",
      meaning: "Cold deepens and the season asks for warmth and care.",
      mood: "Cold / Cozy / Gentle",
      balance: "Soft warmth / Pearl-look / Comfort",
      wear: "Cozy styling / Pearls or pearl-look / Soft gold or silver-tone",
      copy: "Xiaohan deepens the winter cold and calls for warmer, softer styling. Dress with cozy pieces, pearl-look details, and soft gold or silver-tone jewelry."
    },
    {
      slug: "dahan",
      zh: "大寒",
      roman: "Dahan",
      english: "Major Cold",
      month: 1,
      day: 20,
      season: "Winter",
      meaning: "The coldest moment closes the year before spring returns.",
      mood: "Deep / Grounded / Refined",
      balance: "Depth / Structure / Classic polish",
      wear: "Grounding pieces / Deeper tones / Refined classics",
      copy: "Dahan closes the solar-term year at its coldest point before spring returns. Dress with grounding pieces, deeper tones, and refined classics."
    }
  ];

  const MONTHS_LONG = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  const MONTHS_SHORT = MONTHS_LONG.map((month) => month.slice(0, 3));
  const DAY_MS = 24 * 60 * 60 * 1000;

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function atNoon(year, month, day) {
    return new Date(year, month - 1, day, 12, 0, 0, 0);
  }

  function solarYearFor(date) {
    const lichun = atNoon(date.getFullYear(), 2, 4);
    return date < lichun ? date.getFullYear() - 1 : date.getFullYear();
  }

  function startForTerm(term, solarYear) {
    return atNoon(term.month >= 2 ? solarYear : solarYear + 1, term.month, term.day);
  }

  function formatDate(date, mode = "long", includeYear = false) {
    const months = mode === "short" ? MONTHS_SHORT : MONTHS_LONG;
    const base = `${months[date.getMonth()]} ${date.getDate()}`;
    return includeYear ? `${base}, ${date.getFullYear()}` : base;
  }

  function formatRange(start, end, includeYear = false) {
    const sameMonth = start.getMonth() === end.getMonth();
    const sameYear = start.getFullYear() === end.getFullYear();
    if (sameMonth && (!includeYear || sameYear)) {
      return `${MONTHS_LONG[start.getMonth()]} ${start.getDate()} - ${end.getDate()}${includeYear ? `, ${start.getFullYear()}` : ""}`;
    }
    if (includeYear && sameYear) {
      return `${MONTHS_LONG[start.getMonth()]} ${start.getDate()} - ${MONTHS_LONG[end.getMonth()]} ${end.getDate()}, ${start.getFullYear()}`;
    }
    return `${formatDate(start, "long", includeYear)} - ${formatDate(end, "long", includeYear && !sameYear)}`;
  }

  function getCurrentTerm(now = new Date()) {
    const today = atNoon(now.getFullYear(), now.getMonth() + 1, now.getDate());
    const solarYear = solarYearFor(today);
    const periods = TERMS.map((term, index) => {
      const nextTerm = TERMS[(index + 1) % TERMS.length];
      const start = startForTerm(term, solarYear);
      let nextStart = startForTerm(nextTerm, solarYear);
      if (nextStart <= start) nextStart = startForTerm(nextTerm, solarYear + 1);
      return {
        ...term,
        index,
        start,
        end: new Date(nextStart.getTime() - DAY_MS),
        next: {
          ...nextTerm,
          start: nextStart
        },
        solarYear
      };
    });

    return periods.find((period) => today >= period.start && today <= period.end) || periods[0];
  }

  function fullName(term) {
    return `${term.zh} / ${term.roman} / ${term.english}`;
  }

  function termSlugFromMarker(marker) {
    const value = `${marker.dataset.term || ""} ${marker.getAttribute("aria-label") || ""}`.toLowerCase();
    const match = TERMS.find((term) => value.includes(term.roman.toLowerCase()) || value.includes(term.slug));
    return match?.slug || "";
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach((node) => {
      node.innerHTML = value;
    });
  }

  function updateHome(root, current) {
    root.querySelectorAll("[data-ttf-seasonal-home-term]").forEach((card) => {
      setText(card, "[data-ttf-seasonal-term-name]", escapeHtml(fullName(current)));
      setText(card, "[data-ttf-seasonal-term-dates]", escapeHtml(formatRange(current.start, current.end)));
    });
  }

  function recommendationCopy(current) {
    const seasonCopy = {
      Spring: [
        ["Fresh seasonal shine", "Light pieces and soft shine for a fresher seasonal rhythm."],
        ["Clear, delicate accents", "Clear stones and gentle details for spring outfits."],
        ["Soft organic lines", "Pearl-look or organic shapes when the season feels new and open."]
      ],
      Summer: [
        ["Reflective brightness", "Clear shine and warm metal for the brightest days of the season."],
        ["Light-catching accents", "Crystal-like details and polished surfaces for summer visibility."],
        ["Ease with impact", "Statement earrings or clean accents that feel luminous without heaviness."]
      ],
      Autumn: [
        ["Polished refinement", "Classic lines and calmer shine for autumn&apos;s clearer mood."],
        ["Cool-tone clarity", "Silver-tone or clear accents for a focused seasonal finish."],
        ["Grounded structure", "Deeper tones and structured shapes as the air begins to settle."]
      ],
      Winter: [
        ["Quiet winter shine", "Soft sparkle and close-to-body pieces for colder days."],
        ["Warm metal accents", "Gold-tone or pearl-look details for layered winter outfits."],
        ["Grounded classics", "Refined pieces and deeper tones for a calm seasonal finish."]
      ]
    };
    return seasonCopy[current.season] || seasonCopy.Summer;
  }

  function updateEdit(root, current) {
    setText(root, "[data-ttf-seasonal-source]", `Solar term year: ${escapeHtml(formatDate(startForTerm(TERMS[0], current.solarYear), "short"))}, ${current.solarYear} - ${escapeHtml(formatDate(startForTerm(TERMS[TERMS.length - 1], current.solarYear), "short"))}, ${current.solarYear + 1}`);
    setText(root, "[data-ttf-seasonal-wheel-desc]", `A circular year wheel grouped into spring, summer, autumn, and winter. ${escapeHtml(current.roman)} on ${escapeHtml(formatDate(current.start, "short"))} is highlighted as the current solar term.`);
    setText(root, "[data-ttf-seasonal-season-pill]", escapeHtml(current.season));
    setText(root, "[data-ttf-seasonal-term-name]", escapeHtml(fullName(current)));
    setText(root, "[data-ttf-seasonal-term-date]", escapeHtml(formatRange(current.start, current.end, true)));
    setText(root, "[data-ttf-seasonal-term-copy]", current.copy);
    setText(root, "[data-ttf-seasonal-mood]", escapeHtml(current.mood));
    setText(root, "[data-ttf-seasonal-balance]", escapeHtml(current.balance));
    setText(root, "[data-ttf-seasonal-wear]", escapeHtml(current.wear));
    setText(root, "[data-ttf-seasonal-next]", `Next: ${escapeHtml(current.next.roman)} / ${escapeHtml(current.next.english)} starts ${escapeHtml(formatDate(current.next.start, "long", true))}.`);

    root.querySelectorAll("[data-ttf-seasonal-recommendation]").forEach((card, index) => {
      const rec = recommendationCopy(current)[index];
      if (!rec) return;
      const title = card.querySelector("[data-ttf-seasonal-rec-title]");
      const copy = card.querySelector("[data-ttf-seasonal-rec-copy]");
      const image = card.querySelector("img");
      if (title) title.innerHTML = rec[0];
      if (copy) copy.innerHTML = rec[1];
      if (image) image.alt = `${rec[0].replace(/&apos;/g, "'")} for the ${current.roman} seasonal edit`;
    });
  }

  function resetMarker(marker) {
    marker.classList.remove("ttf-current", "current");
    marker.querySelectorAll(".ttf-current-halo, .ttf-current-badge, .ttf-current-badge-text, .current-halo, .current-badge, .current-badge-text").forEach((node) => node.remove());
    marker.querySelectorAll("circle:not(.ttf-current-halo):not(.current-halo)").forEach((circle) => circle.setAttribute("r", "9"));
  }

  function markCurrent(marker) {
    const isThemeMarker = marker.classList.contains("ttf-term-marker");
    const currentClass = isThemeMarker ? "ttf-current" : "current";
    const haloClass = isThemeMarker ? "ttf-current-halo" : "current-halo";
    const badgeClass = isThemeMarker ? "ttf-current-badge" : "current-badge";
    const badgeTextClass = isThemeMarker ? "ttf-current-badge-text" : "current-badge-text";
    const baseCircle = marker.querySelector("circle:not(.ttf-current-halo):not(.current-halo)");

    marker.classList.add(currentClass);
    if (baseCircle) {
      baseCircle.setAttribute("r", "14");
      baseCircle.insertAdjacentHTML(
        "beforebegin",
        `<circle class="${haloClass}" r="25"></circle><rect class="${badgeClass}" x="-28" y="-69" width="56" height="22" rx="11"></rect><text class="${badgeTextClass}" y="-53">NOW</text>`
      );
    }
  }

  function updateMarkers(root, current) {
    const markers = root.querySelectorAll(".ttf-term-marker, .term-marker");
    markers.forEach(resetMarker);
    markers.forEach((marker) => {
      if (termSlugFromMarker(marker) !== current.slug) return;
      markCurrent(marker);
      marker.dataset.date = formatDate(current.start, "short");
      marker.dataset.term = fullName(current);
      marker.dataset.meaning = current.meaning;
      marker.setAttribute("aria-label", `${fullName(current)}. ${current.meaning}`);
    });
  }

  function init(scope = document) {
    const current = getCurrentTerm();
    updateHome(scope, current);
    updateEdit(scope, current);
    updateMarkers(scope, current);
  }

  window.TTFSolarTerms = {
    terms: TERMS,
    getCurrentTerm,
    init
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
